// GENERATED by scripts/gen-icons.mjs — do not edit.
// Run `npm run gen:icons` after bumping lucide-react.

import {
    Combine,
    Command,
    Compass,
    Component,
    Computer,
    ConciergeBell,
    Cone,
    Construction,
    Contact,
    ContactRound,
    Container,
    Contrast,
    Cookie,
    CookingPot,
    Copy,
    CopyCheck,
    CopyMinus,
    CopyPlus,
    CopySlash,
    CopyX,
    Copyleft,
    Copyright,
    CornerDownLeft,
    CornerDownRight,
    CornerLeftDown,
    CornerLeftUp,
    CornerRightDown,
    CornerRightUp,
    CornerUpLeft,
    CornerUpRight,
    Cpu,
    CreativeCommons,
    CreditCard,
    CreditCardCheck,
    CreditCardMinus,
    CreditCardPlus,
    CreditCardReader,
    CreditCardX,
    Croissant,
    Crop,
} from "lucide-react";
import type { LucideIcon } from "lucide-react";

/** The 40 lucide icons from "combine" through "crop", inclusive. */
const shard: Record<string, LucideIcon> = {
    combine: Combine,
    command: Command,
    compass: Compass,
    component: Component,
    computer: Computer,
    "concierge-bell": ConciergeBell,
    cone: Cone,
    construction: Construction,
    contact: Contact,
    "contact-round": ContactRound,
    container: Container,
    contrast: Contrast,
    cookie: Cookie,
    "cooking-pot": CookingPot,
    copy: Copy,
    "copy-check": CopyCheck,
    "copy-minus": CopyMinus,
    "copy-plus": CopyPlus,
    "copy-slash": CopySlash,
    "copy-x": CopyX,
    copyleft: Copyleft,
    copyright: Copyright,
    "corner-down-left": CornerDownLeft,
    "corner-down-right": CornerDownRight,
    "corner-left-down": CornerLeftDown,
    "corner-left-up": CornerLeftUp,
    "corner-right-down": CornerRightDown,
    "corner-right-up": CornerRightUp,
    "corner-up-left": CornerUpLeft,
    "corner-up-right": CornerUpRight,
    cpu: Cpu,
    "creative-commons": CreativeCommons,
    "credit-card": CreditCard,
    "credit-card-check": CreditCardCheck,
    "credit-card-minus": CreditCardMinus,
    "credit-card-plus": CreditCardPlus,
    "credit-card-reader": CreditCardReader,
    "credit-card-x": CreditCardX,
    croissant: Croissant,
    crop: Crop,
};

export default shard;
